// paths
import { stakeholderPaths } from "common/data/routePaths"
import { lazy } from "react"

// beneficiary list table
const BeneficiaryList = lazy(() =>
  import("pages/Stakeholders/CustomerStakeholders/BeneficiaryList"),
)
// beneficiary list form
const BeneficiaryForms = lazy(() =>
  import(
    "pages/Stakeholders/CustomerStakeholders/BeneficiaryList/BeneficiaryForms"
  ),
)
const EmploymentCertificate = lazy(() =>
  import(
    "pages/Stakeholders/CustomerStakeholders/BeneficiaryList/EmploymentCertificate"
  ),
)

// destructure the stakeholders paths object
const { beneficiaryList, printCertificate } = stakeholderPaths

export const CustomerStakeholdersRoutes = [
  // Beneficiary List
  { path: beneficiaryList, component: BeneficiaryList },

  //Edit Beneficiary
  {
    path: `${beneficiaryList}/edit/:beneficiaryId`,
    component: BeneficiaryForms,
  },
  //View Beneficiary
  {
    path: `${beneficiaryList}/view/:beneficiaryId`,
    component: BeneficiaryForms,
  },
  {
    path: `${beneficiaryList}/${printCertificate}/:beneficiaryId`,
    component: EmploymentCertificate,
  },
]
